"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import { AdvSearchBedroomGroupButtonV2 } from "./AdvSearchBedroomGroupButtonV2";

export function AdvSearchBedroomGroup({ children = "" }) {
  return (
    <Block className={" bedroom-group"} tag={"div"}>
      <Block className={" adv-search-lable"} tag={"div"}>
        {"Bedrooms"}
      </Block>
      <Block className={"bedroom-option"} tag={"div"}>
        {children ?? (
          <>
            <AdvSearchBedroomGroupButtonV2
              showActive={false}
              showInActive={true}
              text={"studio"}
            />
            <AdvSearchBedroomGroupButtonV2
              showActive={true}
              showInActive={false}
              text={"1"}
            />
            <AdvSearchBedroomGroupButtonV2
              showActive={false}
              showInActive={true}
              text={"1"}
            />
            <AdvSearchBedroomGroupButtonV2
              showActive={false}
              showInActive={true}
              text={"1"}
            />
            <AdvSearchBedroomGroupButtonV2
              showActive={false}
              showInActive={true}
              text={"2"}
            />
          </>
        )}
      </Block>
    </Block>
  );
}
